import { useContext, useEffect } from 'react'
import styled from 'styled-components'

import { StoresContext } from '../../../provider/StoreProvider'

import { useUserInfo } from '../../../hooks/useUserInfo'

import { Wrap } from '../../../components/container/Wrap'
import { Content } from '../../../components/container/Content'
import { Header } from '../../../components/header'
import { Deposit } from './Deposit'
import { Transaction } from './Transaction'

export function Account() {
  const {
    commonStore: { setShowTab, setInvalidAccess },
  } = useContext(StoresContext)

  const { isLogin, isCheckingLogin } = useUserInfo()

  useEffect(() => {
    setShowTab(false)
  }, [])

  useEffect(() => {
    if (!isLogin && !isCheckingLogin) setInvalidAccess(true)
  }, [isLogin, isCheckingLogin])

  return (
    <Wrap>
      <Header type="SUB" title="입출금 내역" />
      <StyledContent id="infinity-scroll-target">
        <Deposit />
        <Transaction />
      </StyledContent>
    </Wrap>
  )
}

const StyledContent = styled(Content)`
  padding-bottom: 16px;
`
